/* Observership external application: Reset Password page
 * Page will display success/fail message for password reset result
 * The success message should contain login link 
 
 * author: @ch168189
 * created: 09/07/2023
 
 */
 
 import React, {useState, useRef,useContext, useEffect} from "react";
  import ReCAPTCHA from "react-google-recaptcha";
 import Button from "../framework/Button";
 import Ribbon from "../framework/Ribbon";
 import InputTxt from "../framework/InputTxt";
 import {useLocation} from "react-router-dom"; 
 import webRootContext from "../components/webrootcontext/WebRootContext";
 import {Formik} from "formik";

 import { AppConfiguration } from "../framework/AppConfigProvider";
 
 function ResetPassword(props) {
    const localConfig = useContext(AppConfiguration);
    const location = useLocation();
  
    const [curUserName, setCurUserName] = useState();
    const [resetResult, setResetResult] = useState();  
    const [showResult, setShowResult] = useState();
    const [formSubmitted, setFormSubmitted] = useState();
    const [responseError, setResponseError] = useState("");
    const [showForm, setShowForm] = useState();  
    
    const captchaRef = useRef(null);
    const verifyRecaptcha_api_url =  webRootContext + "/rest/captchaservice/verifyCaptcha";
    
	
	
	
	                   
	const iconParent = {display: 'flex'};
	
						  
	const successMsgTitle = <div>Your password has been successfully updated.</div>
	const successMsgContent = <div>	
	                        <div className="padding-bottom-30">You may now <a href="./login">log in</a> and complete your application.</div>						    						
							<div>
							 	<Button
						                text={"Log in"}
						                styleName={"button button--primary"}
						                id={"login"}
						                onClick={(e) => navPage(e)} 
						               />
						     </div>
	                      </div>;
	const invalidTokenMsgContent = <div className="padding-bottom-30">
						   Invalid user or expired token. 
				          </div>;
	
	const errResetMsgTitle = <div>Sorry, there is a problem on our end.</div>
	const errResetMsgContent = <div>
							<div class="first-level">Refresh the page</div> 
							<div class="first-level">Try again in 30 minutes</div> 
							<div  class="first-level">Report this issue and the time that it occurred to <a href="mailto:observership.program@childrens.harvard.edu"> observership.program@childrens.harvard.edu</a></div>
							</div>;
				          
				          
    const validatePasswordMsg = <div>
	<ul>
	  <li>At least 8 characters long</li>
	  <li>Max 30 characters long</li>
	  <li>Contains at least one uppercase letter</li>
	  <li>Contains at least one lowercase letter</li>
	  <li>Contains at least one digit</li>
	  <li>Contains at least one special character from the set @$!%*#?&</li>
	</ul> </div>;
	
	
	window.recaptchaOptions = {
	  useRecaptchaNet: true
	  
	};
	
	let captChaContent=<div></div>;
	if(localConfig.configProperties.captchaSiteKey!=null){
	  captChaContent = <ReCAPTCHA sitekey={localConfig.configProperties.captchaSiteKey}  ref={captchaRef}  />		
	}	
	
	function submitFormWithCaptchaToken(newPassword){
        const token = captchaRef.current.getValue();				  	
		captchaRef.current.reset();	
		setShowForm(false);
		  				
		if(token == null  || token === ""){
			setResponseError("Please check Captcha checkbox ");	
			setShowForm(true);		
			return;
		}
		
		 fetch(verifyRecaptcha_api_url, {
		      	method: 'POST', 
		   		headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
						},
				body: token,
		    	mode:"cors"})
	 		    .then((response) => {
					 return response.status;			  
			    })
			    .then((result) => {
				    
				    if(result === 200){                  
	                   updatePassword(newPassword);
	                   	                     
				   }else{					  
					   setResponseError("Captcha service error");
					   setShowForm(true);
				   }
				   
				  
			  });
    }
    
	function updatePassword(newPassword){
         const updatePassword_api_url =  webRootContext + "/rest/usermanagement/updatePassword?" ;
         let pwd = {"email": curUserName,
			       "newPassword": newPassword};
			       
        fetch(updatePassword_api_url, {
			method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			mode: "cors", 
			body: JSON.stringify(pwd) 
			})
			.then((response) => {
				return response.json();
				
			})
			.then((data) => {	
                		
				setResetResult(data);  
				setShowResult(true);
                			
			},(error) => {
                console.log("new api error ", error);
				
				setResetResult(0);  
				setShowResult(true);
			});	
        
    }
	
    function navPage(event){
	   let id = event.target.id;
		switch (id){
			case "login": window.location.href =  webRootContext + "/Login"; break;		
			default: 
				window.location.href =  webRootContext ;  return;
		}
		
		
	}
	
	function validatePassword(checkPassword) {
		let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&]).{8,30}$/; 		
		return reg.test(checkPassword);
	}	
	
	
	
	
	useEffect(() => {	   
	    const queryParameters = new URLSearchParams(location.search);
	    const verifyResetToken_api_url =  webRootContext + "/rest/usermanagement/verifyPwdReset?" + queryParameters.toString() ;
	    
	    const userName = queryParameters.get("user");
	    const token = queryParameters.get("token");
	    setCurUserName(userName);
	    
	    if(token == null || token === "" || userName == null || userName === ""){
            setShowForm(false);
            setShowResult(true);
			setResetResult(-1);  
			return;
		}
		
		fetch(verifyResetToken_api_url, {
			method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			mode: "cors"})
			.then((response) => {
				return response.json();
				
			})
			.then((data) => {
				
				if(data === 1) {
     				setShowForm(true);
                }else{
                 	setShowForm(false);
                 	setShowResult(true);
					setResetResult(-1);  
                }
				
				
			},(error) => {
				setShowForm(false);
				setShowResult(true);
				setResetResult(-1);  
			});		
	}, [ location.search])
	
	
    return (
      <div className="div_3_col" id="resetpassword" >
      	<Formik
      	    initialValues={{
                  userPassword: "",
                  userConfirmPassword: "",
                  
              }}
             validateOnChange={false}
      	     validate={values => {
         		const errors = {};
         		
         		
         		       		
         		 if (!values.userPassword || values.userPassword.trim().length === 0) {
				           errors.userPassword = 'Password is required';			           
				 }else if (values.userPassword && (!validatePassword(values.userPassword))){
                     errors.userPassword = 'Not a valid password format';
                 }
				         
				  if (!values.userConfirmPassword || values.userConfirmPassword.trim().length === 0) {
		           errors.userConfirmPassword = 'Retype Password is required';
		        } else if (values.userConfirmPassword !== values.userPassword) {
		           errors.userConfirmPassword = 'Passwords must match';
		        } 
		        
		         if( Object.keys(errors).length > 0) {
               			
						setResponseError("REVIEW ISSUES BELOW");
				  } else {
			          setResponseError("");
			      }	
				         
				                 
         		return errors;
         	  }}
         	   onSubmit={(values, { setSubmitting, resetForm }) => {
                    setTimeout(() => {                     
                        submitFormWithCaptchaToken(values.userPassword);
                        setSubmitting(false);
		     	            	
                        }, 100);
		        
                }}
            >
             {({
		          values /* all data need to run the valdation*/,
		          errors /* all error strings */,
		          touched/* all field touch event  */,
		          handleChange /* value change event handler */,
		          handleBlur /* onBlur event handler */,
		          handleSubmit /* for submit button */,
		          isSubmitting /* for submit button */,
		          isValid /* for submit button */,
		          dirty /* for submit button */,
		          validateForm
		          /* and other goodies */
		        }) => (
				
				 <form onSubmit={handleSubmit} noValidate>
				 
				 <div id="resetResult" className={showResult?'show_div' : 'hide_div'}>     		     
	      		     	<Ribbon label={resetResult === 1? "submitted":"error"} status={resetResult ===1?"checkmark":"error"} subheader={resetResult === 1? successMsgTitle :(resetResult === -1? null : errResetMsgTitle)} content={resetResult === 1? successMsgContent :(resetResult === -1? invalidTokenMsgContent: errResetMsgContent) } />    		           		     
	      		</div>
	      		
	      		<div id="formikErrors" className={( responseError !== "" && formSubmitted ? 'show_div' : 'hide_div')}>
	               <div id="formikFailDiv">
	               		<Ribbon label={responseError} status={"error"} subheader={""} content={""} />
	               </div>
	          </div>
	          
	      		<div className={showResult? 'hide_div' : 'show_div page_title'}>Reset Password</div>
	      		<div className="div_3_col padding-bottom-30"></div>
      		
      		 
      		
      		<div className={showForm?'show_div' : 'hide_div'}>
      		   <div className="horizontal_div">
      		   		    		   		   
	      		   <div style={iconParent} > 
		      		
		      		   	<InputTxt id="userPassword"
		      		   				 name="userPassword" 
					                labelText="New Password"      
					                isRequired={true} 
					                 maxLength={30}	
					                type="password"	                
					                helpMessage = {validatePasswordMsg}  
					                errorMessage={errors.userPassword}         
					                hasError={touched.userPassword && errors.userPassword}                               
					                onChange={ handleChange}
					                onBlur={handleBlur}  
			                   />
			                  
	      		   </div>
      		   	
      		   		      		   		
	      		   <div style={iconParent} > 		               
		      		   	<InputTxt id="userConfirmPassword"
		      		   				 name="userConfirmPassword" 
					                labelText="Retype Password" 
					                maxLength={30}	     
					                isRequired={true} 					               
					                type="password"	
					                helpMessage = ""  
					                errorMessage={errors.userConfirmPassword}         
					                hasError={touched.userConfirmPassword && errors.userConfirmPassword}                               
					                onChange={handleChange}
					                onBlur={handleBlur}  
			                   />
	      		   </div>
      		   		
      		   	
	  		   		
	      		   
	      		    
      		   </div>
      		   
  		       <hr className="hr--light" />
		             
	             <div className="padding-bottom-30">
	             	{captChaContent}		              
	             </div>
		             
      		   <div>
      		   		 <Button
		                text={"Reset Password"}
		                styleName={"button button--primary"}
		                id={"button_submit"}
		                type="submit"
		                onClick={(e) =>{setFormSubmitted(true); validateForm();}}
		              />
      		   </div>
      		</div>
      		
      		
      		
      	
      		
      		</form>
      		)}
      
        </Formik>
      </div>
     
    )
 };
 
 export default ResetPassword;